import { render, staticRenderFns } from "./Large.vue?vue&type=template&id=b2a931c4"
import script from "./Large.vue?vue&type=script&lang=js"
export * from "./Large.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports